import { PaymentMethodEnum } from '../../../lib/enums';
import lang from '../../../lib/language';

import iconBank from '../../../assets/img/icon-bank.svg';
import iconDebitCredit from '../../../assets/img/icon-debit-credit.svg';
import iconInternalTransfer from '../../../assets/img/internal-transfer-icon.svg';

export const depositOptions = [
  {
    id: PaymentMethodEnum.InternalTransfer,
    title: lang.fundScreenInternalTransfer(),
    description: lang.commonFundPortalMoveFunds(),
    icon: iconInternalTransfer,
  },
  {
    id: PaymentMethodEnum.Card,
    title: lang.commonFirstDepositCard(),
    description: lang.commonFirstDepositCardInstant(),
    icon: iconDebitCredit,
  },
  {
    id: PaymentMethodEnum.BankTransfer,
    title: lang.commonFirstDepositBank(),
    description: lang.commonFirstDepositBankDescription(),
    icon: iconBank,
  },
];
